import xhrRequest from './xhr-request';
import ymcHeaderDecode from './ymc-header-decode';

let DEFAULT_CFG = { time: 0, openUba: false, addr: '' };
/**
 * 获取服务端配置信息
 */
export default (url: string): Promise<{
  time: number,
  openUba: boolean,
  addr?: string,
}> => {
  return xhrRequest(url, { returnXHR: true }).then((xhr: XMLHttpRequest) => {
    try {
      const ymcData = ymcHeaderDecode(xhr.getResponseHeader('X-Ymc-Access-Data'));
      const ret: any = JSON.parse(xhr.response);
      DEFAULT_CFG = {
        time: Number(ret.timestamp) || 0,
        openUba: !!ret.openUba,
        addr: ymcData?.remote_addr,
      };
      return DEFAULT_CFG;
    } catch (error) {
      hbLogger.error('get server config error', error);
    }
    return DEFAULT_CFG;
  }).catch(() => DEFAULT_CFG);
}
